module.exports = __webpack_public_path__ + "static/hero-bg-sp-5f3585c6d4874bf4457f983e3bfcae38.png";